import { useEffect, useState } from 'react'
import { PolicyPage, PageShell } from './PolicyPage'
import { supabase } from '../supabase'
export default function FAQ() {
  useEffect(() => { document.title = 'FAQ — SYNINN' }, [])
  const [faqs, setFaqs] = useState([])
  const [loading, setLoading] = useState(true)
  const [openId, setOpenId] = useState(null)
  useEffect(() => {
    supabase.from('faqs').select('*').eq('active', true).order('created_at').then(({ data }) => {
      setFaqs(data || [])
      setLoading(false)
    })
  }, [])
  return (
    <PageShell title="FAQ" subtitle="Frequently asked questions">
      {loading && <p style={{ color: '#666', padding: '40px 0', textAlign: 'center' }}>Loading...</p>}
      {!loading && faqs.length === 0 && <p style={{ color: '#666', padding: '40px 0', textAlign: 'center' }}>No FAQs available yet.</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {faqs.map(faq => (
          <div key={faq.id} style={{ background: '#111', border: `1px solid ${openId === faq.id ? '#C9A84C44' : '#1a1a1a'}`, borderRadius: '12px', overflow: 'hidden' }}>
            <button onClick={() => setOpenId(openId === faq.id ? null : faq.id)} style={{ width: '100%', padding: '14px 16px', background: 'transparent', border: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', textAlign: 'left' }}>
              <span style={{ fontSize: '13px', color: '#fff', fontWeight: '500', flex: 1, paddingRight: '12px' }}>{faq.question}</span>
              <span style={{ fontSize: '16px', color: '#C9A84C', flexShrink: 0 }}>{openId === faq.id ? '−' : '+'}</span>
            </button>
            {openId === faq.id && <div style={{ padding: '0 16px 14px', fontSize: '13px', color: '#888', lineHeight: '1.8', borderTop: '1px solid #1a1a1a', paddingTop: '12px' }}>{faq.answer}</div>}
          </div>
        ))}
      </div>
    </PageShell>
  )
}